import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import { clearCart } from "../../../../store/Actions/cartActions";
import { formatOrderDate } from "../../../../utils/orders";
import { ResultScreen } from "../../Feedback";
import { Icon, OnboardingIcons } from "../../OnboardingLayout";

/* Illustration du design ; l'ancienne image tant que le fichier n'est pas livré. */
const ILLUSTRATION = "/assets/imgs/illustration-commande.png";
const FALLBACK = "/assets/imgs/order_confirm_pic.png";

const capitalise = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text);

/**
 * « Lun. 5 oct. · 14:00 – 16:00 », comme l'écran 07 du design.
 * `slot` : { key: "2026-10-05", slot: "14:00-16:00" }.
 */
export const slotLabel = (slot, lang) => {
  const date = capitalise(formatOrderDate(slot?.key, lang));
  const range = slot?.slot ? String(slot.slot).replace("-", " – ") : "";
  return [date, range].filter(Boolean).join(" · ");
};

/**
 * Commande confirmée — design « Pop-ups et confirmations », écran 07.
 *
 * Le checkout passe dans l'état de navigation le numéro de commande et les
 * deux créneaux ({ orderNumber, pickup, delivery }). Sans eux (ancien
 * parcours, rechargement de la page), la pastille et l'encart disparaissent
 * plutôt que d'afficher des valeurs inventées.
 *
 * Animations : bulles qui montent, illustration fixe (voir ResultScreen).
 */
const PaymentSuccess = ({ dispatch, history, location }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "fn" ? "fr" : i18n.language === "du" ? "nl" : "en";
  const summary = location?.state || {};

  useEffect(() => {
    dispatch(clearCart());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const facts = [
    summary.pickup && { label: t("Pickup"), value: slotLabel(summary.pickup, lang) },
    summary.delivery && { label: t("Delivery"), value: slotLabel(summary.delivery, lang) },
  ].filter((fact) => fact && fact.value);

  return (
    <>
      {/* Sprite des pictos (#ob-check de la pastille). */}
      <OnboardingIcons />
      <ResultScreen
        tone="success"
        halo="wide"
        float={false}
        art="medium"
        illustration={ILLUSTRATION}
        fallbackIllustration={FALLBACK}
        badge={
          summary.orderNumber ? (
            <>
              <Icon name="check" />
              {t("Order no. {{number}}", { number: summary.orderNumber })}
            </>
          ) : null
        }
        title={t("Thank you, your order is confirmed!")}
        lede={t("We will collect your laundry at the chosen slot. You will get a notification at each step.")}
        facts={facts}
        actions={[
          { label: t("Back to the home page"), onClick: () => history.push("/home") },
          { label: t("Track my order"), onClick: () => history.push("/orders"), primary: true },
        ]}
      />
    </>
  );
};

export { PaymentSuccess };

export default connect()(PaymentSuccess);
